import PropTypes from "prop-types";
import { childrenPropType, classNamePropType } from "../../common";

/**
 * PropTypes for GridContainer component
 *
 * @property {React.ReactNode} children - Grid items
 * @property {string} [className] - Additional CSS classes
 * @property {number} [columns] - Number of columns in grid
 * @property {number} [gap] - Gap between grid items in pixels
 * @property {string} [templateColumns] - Custom grid-template-columns CSS value
 */
export const gridContainerPropTypes = {
  children: childrenPropType,
  className: classNamePropType,
  columns: PropTypes.number,
  gap: PropTypes.number,
  templateColumns: PropTypes.string,
};
